<!-- 机票航程  仓位列表 订单填写弹出层  订单详情 改签退票详情 展示  -->
<template>
  <div>
    <van-cell class="round-sm">
      <van-row
        type="flex"
        align="center"
        class="title"
      >
        <van-col span="20">
          <slot name="tag" />
          <van-tag class="tag-green">
            <span class="font10" v-if="flight.snStr">{{ flight.snStr }}</span>
            <span class="font10" v-else>第{{ index + 1 }}程</span>
          </van-tag>
          {{ flight.departDate }} {{ flight.departDate|week }}
          {{ flight.nDepartDate }} {{ flight.nDepartDate|week }}
          {{ flight.oDepartDate }} {{ flight.oDepartDate|week }}
          <span v-show="flight.flyTimeStr"><van-icon name="clock-o" />  时长{{
            flight.flyTimeStr || flight.nFlyTime
          }}</span>
          <slot name="tag-less" />
        </van-col>
        <van-col
          span="4"
          class="text-right"
        >
          <van-checkbox
            class="fr"
            v-model="flight.checked"
            v-show="showCheck"
            @change="$emit('selected',index2,flight.checked)"
          />
          <slot name="right" />
        </van-col>
      </van-row>

      <!--  -->
      <div>
        <van-row
          type="flex"
          align="center"
          v-if="showCabin&&flight.cabin&&flight.cabin.cabinName"
          class="row"
        >
          <van-col span="12">
            {{ flight.cabin.cabinName }} <span class="red"><span class="font10">&yen;</span> {{
              flight.price.salePrice
            }}</span>
          </van-col>
          <van-col
            span="12"
          />
        </van-row>
        <div class="relative">
          <van-row
            type="flex"
            align="center"
            class="row font16"
          >
            <van-col span="4">
              {{ flight.departTime }} {{ flight.nDepartTime|time }} {{ flight.oDepartTime }}
            </van-col>
            <van-col span="2">
              <van-icon
                name="circle"
                class="line-top"
              />
              <span class="line" />
              <van-icon
                name="circle"
                class="line-bottom"
              />
            </van-col>
            <van-col span="12">
              {{ flight.departCityName }}
              {{ flight.departAirportName }}{{
                flight.nDepartAirportName|airportName
              }}{{ flight.oDepartCityName|airportName }} {{ flight.departTerminal }}
            </van-col>
            <van-col span="2">
              <span
                v-show="showClear"
                @click="$emit('delet',index2)"
              ><van-icon
                class="main-color"
                name="clear"
              /></span>
            </van-col>
            <van-col
              span="4"
              class="text-right"
            >
              <van-button
                v-show="showCar && showCar2"
                type="default"
                size="small"
                @click="goto(1, flight)"
              >
                送机
              </van-button>
            </van-col>
          </van-row>

          <van-row v-show="flight.stopNum>0">
            <van-col span="5" />
            <van-col span="19">
              <div class="stopList font12 gray bg-gray">
                <span class="stop main-color">停</span>&nbsp; 经停：
                <span
                  v-for="(ct ,index) in flight.stopOverList"
                  :key="index"
                > {{ ct.cityName }} {{ ct.airportName }}  <br>{{ $t('ddsj', '到达时间') }}：{{
                  ct.arriveTime
                }}  {{ $t('C124', '起飞时间') }}：{{ ct.departTime }}
                </span>
              </div>
            </van-col>
          </van-row>
          <van-row
            type="flex"
            align="center"
            class="row font16"
          >
            <van-col span="4">
              {{ flight.arriveTime }} {{ flight.nArriveTime|time }} {{ flight.oArriveTime }}
            </van-col>
            <van-col span="2" />
            <van-col span="14">
              {{ flight.arriveCityName }}
              {{ flight.arriveAirportName }}{{
                flight.nArriveAirportName|airportName
              }}{{ flight.oArriveCityName|airportName }} {{ flight.arriveTerminal }}
            </van-col>
            <van-col
              span="4"
              class="text-right"
            >
              <van-button
                v-show="showCar && showCar2"
                type="default"
                size="small"
                @click="goto(0, flight)"
              >
                接机
              </van-button>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="title gray">
        <img
          :src="flight.airlineImg"
          v-show="flight.airlineImg"
          class="airIcon"
        >
        {{ flight.airlineName }}
        <span>|  {{ flight.flightNo || flight.nFlightNo || flight.oFlightNo }}</span>
        <span v-if="flight.cabinName">|  {{ flight.cabinName }}  </span>
        <span v-else-if="flight.cabin">{{ flight.cabin | cabinFilter }}</span>
        <span v-show="flight.saleDiscount">| {{ flight.saleDiscount|discount }}</span>
        <span v-if="flight.planeMap">| {{
          flight.planeMap[flight.plane].planeName
        }}({{ flight.planeMap[flight.plane].planeBody }})</span>
        <span v-else-if="flight.planeName">| {{ flight.planeName }}</span>
        <span
          class="food"
          v-if="flight.hasFood==1||flight.hasfood==1"
        > | 有餐食
        </span>
        <span
          class="food"
          v-else-if="flight.hasFood===0||flight.hasfood===0"
        > | 无餐食
        </span>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span
          class="foodobj"
          v-if="retreatname" 
        > {{ retreatname }}
        </span>
        <!-- <span
          class="main-color"
          v-show="flight.sharFlightNo"
          @click="$dialog.alert({message:'实际乘坐：'+' '+flight.sharFlightNo+'</br>请按实际乘坐航班办理值机。'})"
        > {{ $t('C132', '共享') }}</span> -->
      </div>
      <div v-if="flight.shareFlightNo" class="shareFightno">实际承运 | {{ flight.shareFlightNo }}</div>

      <div
        v-show="showRule"
        class="line-height-normal pad-t-5 font12 text-center main-color  van-hairline--top"
        @click="rule(flight)"
      >
        {{ $t('F010', '退改签规则') }}
      </div>
      <slot name="bottom" />
    </van-cell>
    <!--  -->
    <refund-change-rule
      ref="rule"
      :obj="changeRule"
      :cplx="cplx"
    />
  </div>
</template>

<script>
import refundChangeRule from 'Components/refundChangeRule/MultiTripCancellationRules'
import {formatDate} from 'Utils/dateUtil.js'
import {Checkbox, Icon, Tag, Cell, Button} from 'vant'
import {localset} from 'Utils/storage'
import {mapState} from 'vuex'
import {queryVipParameter} from 'Utils/publicApi'

export default {
  name: 'Voygae',
  props: {
    flight: {//航班信息
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
    },
    showRule: {//是否显示退改规则按钮
      type: Boolean,
      default: false
    },
    showCheck: {//退改签选中按钮
      type: Boolean,
      default: false
    },
    showClear: {//删除行程按钮
      type: Boolean,
      default: false
    },
    showCabin: {//显示舱位
      type: Boolean,
      default: false
    },
    travelType: {
      type: [String, Number],
      default: '0'
    },
    roundTrip: {
      type: [String, Number],
      default: '0'
    },
    // 是否显示接送机
    showCar: {
      type: Boolean,
      default: false
    },
    // 出差申请单ID
    ccsqdId: {},
    //退name
    retreatname:{}
  },
  components: {
    refundChangeRule,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    [Button.name]: Button,
  },
  computed: {
    ...mapState({
      authorizationPnosMap: state => state.app.authorizationPnosMap,
    })
  },
  data() {
    return {
      changeRule: {},
      cplx: '10901',
      // 是否显示接送机
      showCar2: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.flight.stopNum > 0) {
        this.$api['tkQuery/queryFlightStop']({
          'date': this.flight.departDate,
          'flightNo': this.flight.flightNo
        }).then(res => {
          let cache = res.data || {}
          this.flight.stopOverList = cache.stopList || []
        }).catch(res => {
          console.log(res)
        })
      }
      if (this.flight.international == 1) {
        this.cplx = '10901'
      } else {
        this.cplx = '10902'
      }

      const OPEN_PRO_TYPES = this.authorizationPnosMap.map(i => Number(i.productNo))
      this.showCar2 = OPEN_PRO_TYPES.includes(10906)
      if (this.showCar2) {
        queryVipParameter('11604005').then(res => {
          if (res.value1) {
            let carProType = ['0', '0', '0', '0']
            carProType = res.value1.split(',')
            this.showCar2 = carProType[0] === '1'
          }
        })
      }
    },
    rule(info) {
      this.changeRule = info
      this.$refs.rule.toggle()
    },

    // 跳转页面
    goto(useType, flight) {
      // if (useType === 0) {
      //   localset('refresh_the_page', true);
      // }
      localset('voyage_useType', useType)
      localset('voyage_flight', JSON.stringify(flight))
      this.$router.push({
        path: '/car/carQuery',
        query: {
          useType: useType,
          flight: JSON.stringify(flight),
          ccsqdId: this.ccsqdId
        }
      })
    }
  },
  filters: {
    cabinFilter(param) {
      if (param.hasOwnProperty('cabinName') || param.hasOwnProperty('cabin')) {
        let ctrTxt = param.cabinName || param.cabin
        return `| ${ctrTxt} `
      } else {
        return `| ${param} `
      }
    },
    time(val) {
      if (!val || val.length <= 5) {
        return val
      }
      return formatDate(new Date(val)).hm
    },
    discount(val) {//计算折扣   详情与列表有区别  详情0.45  列表 4.5  rubbish
      if (!val) return
      if (val < 1) {
        return (val * 10).toFixed(1) + '折'
      } else if (val == 1) {
        return '全价'
      } else if (val > 1) {
        val = Math.floor(val) / 10
        return val + '倍'
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.row {
  height: 30px;
}

.title {
  font-size: @font-size-12;
}

.pad-t-5 {
  padding-top: 5px;
}

.stopList {
  display: inline-block;
  padding: 2px 10px 2px 2px;
  border-radius: 10px;
}

.stop {
  display: inline-block;
  padding: 0 4px;
  border-radius: 8px;
  background-color: @color-background-white;
  font-size: @font-size-10;
}

.line {
  display: inline-block;
  position: absolute;
  top: 20px;
  bottom: 20px;
  width: 6px;
  border-right: 1px solid #cccccc;
  height: calc(100% - 40px);
}

.line-bottom, .line-top {
  position: absolute;
  font-size: @font-size-10;
  color: #cccccc;
  background-color: @color-background-white;
}

.line-top {
  top: 10px;
}

.line-bottom {
  bottom: 10px;
}

.tag-green {
  background-image: linear-gradient(-90deg, #45bf9b 0%, #52dcb3 100%), linear-gradient(#eef2f7, #eef2f7);
  background-blend-mode: normal, normal;
  box-shadow: 0px 2px 2px 0px rgba(51, 164, 131, 0.3);
  border-radius: 5px;
  margin: 0 3px 0px 0px;
}
.shareFightno{
    font-size: 12px;
    line-height: 20px;
}
</style>
